export enum BSApiAction {
	GET = 'get',
	SAVE = 'save',
	DELETE = 'delete',
	GEN = 'gen',
	ABL = 'abl',
}
